const TOGGLE_STATISTIC_VISIBILITY = 'TOGGLE_STATISTIC_VISIBILITY'

export default {
  namespaced: true,
  state: {
    showStats: false,
  },
  getters: {
    showStats: state => state.showStats,
  },
  actions: {
    toggleStatisticVisibility({ commit }) {
      commit(TOGGLE_STATISTIC_VISIBILITY)
    },
  },
  mutations: {
    [TOGGLE_STATISTIC_VISIBILITY](state) {
      state.showStats = !state.showStats
    },
  },
}
